import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import CommentService from '../../services/Comments';

const normalizeComments = (response) => {
    if (!response) {
        return [];
    }
    if (Array.isArray(response)) {
        return response;
    }
    if (Array.isArray(response.data)) {
        return response.data;
    }
    if (Array.isArray(response.comments)) {
        return response.comments;
    }
    return [];
};

const RecentComments = ({ recentArticles = [] }) => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const fallbackImage = 'assets/images/blog/img4.png';

    useEffect(() => {
        let isActive = true;

        if (!recentArticles.length) {
            setComments([]);
            setLoading(false);
            return () => {
                isActive = false;
            };
        }

        const loadComments = async () => {
            setLoading(true);
            const commentService = new CommentService();
            const articleMap = recentArticles.reduce((acc, article) => {
                if (article?.id) {
                    acc[article.id] = article;
                }
                return acc;
            }, {});

            const articleIds = Object.keys(articleMap).slice(0, 3);

            try {
                const fetchedComments = await Promise.all(
                    articleIds.map(async (articleId) => {
                        try {
                            const response = await commentService.getComments(articleId);
                            const normalized = normalizeComments(response);
                            if (!normalized.length) {
                                return null;
                            }
                            const latestComment = normalized[0];
                            return {
                                ...latestComment,
                                articleTitle: articleMap[articleId]?.titre,
                            };
                        } catch (error) {
                            console.error('Erreur lors de la récupération des commentaires récents :', error);
                            return null;
                        }
                    })
                );

                if (!isActive) {
                    return;
                }

                setComments(fetchedComments.filter(Boolean));
            } catch (error) {
                console.error('Erreur lors de la récupération des commentaires récents :', error);
                if (isActive) {
                    setComments([]);
                }
            } finally {
                if (isActive) {
                    setLoading(false);
                }
            }
        };

        loadComments();

        return () => {
            isActive = false;
        };
    }, [recentArticles]);

    return (
        <div className="recent-comments mb-4">
            <h5 className="mb-3">COMMENTAIRES RÉCENTS</h5>
            {loading ? (
                <Loader />
            ) : comments.length > 0 ? (
                <ul className="list-unstyled">
                    {comments.map((comment, index) => (
                        <li key={`${comment.id || index}-${index}`} className="d-flex align-items-center mb-3">
                            <img
                                src={comment.image || fallbackImage}
                                alt={comment.nom || comment.user || 'Commentaire récent'}
                                className="comment-image me-3 mb-3"
                            />
                            <div>
                                <p className="mb-1 text-truncate" style={{ maxWidth: 200 }}>
                                    {comment.comment || comment.content || 'Pas de contenu'}
                                </p>
                                <span className="text-muted">{comment.nom || comment.user || 'Utilisateur'}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="text-muted mb-0">Aucun commentaire récent pour le moment.</p>
            )}
        </div>
    );
};

export default RecentComments;
